<script>
  import * as Drawer from "$lib/components/ui/drawer/index.js";
  import * as Popover from "$lib/components/ui/popover/index.js";

  import { buttonVariants } from "$lib/components/ui/button/index.js";
  import CartContent from "./cart-content.svelte";
  import CartTrigger from "./cart-trigger.svelte";
  import { cart } from "$lib/cart-store.svelte.js";
  import { IsMobile } from "$lib/hooks/is-mobile.svelte.js";

  const isMobile = new IsMobile();

  function handleOpenChange(isOpen) {
    if (isOpen) {
      cart.actions.openCart();
    } else {
      cart.actions.closeCart();
    }
  }
</script>

{#if isMobile.current}
  <Drawer.Root open={cart.isCartOpen} onOpenChange={handleOpenChange}>
    <Drawer.Trigger asChild>
      <CartTrigger />
    </Drawer.Trigger>

    <Drawer.Content>
      <div class="mx-auto w-full">
        <CartContent />
      </div>
    </Drawer.Content>
  </Drawer.Root>
{:else}
  <Popover.Root open={cart.isCartOpen} onOpenChange={handleOpenChange}>
    <Popover.Trigger asChild>
      <CartTrigger />
    </Popover.Trigger>

    <Popover.Content
      interactOutsideBehavior="ignore"
      align="end"
      class="min-w-80"
    >
      <CartContent />
    </Popover.Content>
  </Popover.Root>
{/if}
